import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import shipments from './modules/shipments'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    shipments
  }
})
